export const transferAccountTutorialStorageKey = 'transferAccountTutorialShown';
